export default {
  title: 'Você tem SOSAFE?',
  subtitle: 'Se sim, tente as mensagens privadas do SOSAFE',
  action: 'SIM',
};
